export default function  getUrlParam(ind = 1) {
    var url = window.location.hash
    url = url.replace("#", "");
    url = url.split("/");
    return url[ind];
  }
